{
  "(optional)": "(opcijsko)",
  "(required)": "(obvezno)"
}